export class RoleIngestionApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Ingests a role file into an organization's application pool.
     * @returns any
     * @throws ApiError
     */
    process({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/role-ingestion/process',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
